import { IEventsDashboardData } from 'src/apis/dashboard/dashboardEvents.interfaces';

export const dashboardEventsMock: IEventsDashboardData = {
  events: {
    summary: {
      totalCount: 45,
      upcomingCount: 13,
      todayCount: 3,
    },
    status: {
      scheduled: 13,
      completed: 32,
      cancelled: 2,
      ongoing: 1,
    },
    timeBreakdown: {
      past: 32,
      today: 3,
      upcoming: 10,
    },
    byGroup: {
      exam: 12,
      sport: 8,
      cultural: 6,
      technical: 3,
      workshop: 3,
      seminar: 1,
    },
    timeSeries: [
      {
        date: '2024-01-01',
        scheduled: 100,
        completed: 100,
        cancelled: 100,
        total: 100,
      },
      {
        date: '2024-01-02',
        scheduled: 100,
        completed: 100,
        cancelled: 100,
        total: 100,
      },
    ],
  },
  todos: {
    summary: {
      totalCount: 11,
      pendingCount: 8,
      completedCount: 3,
    },
    status: {
      pending: 8,
      inProgress: 3,
      completed: 0,
    },
  },
  period: {
    startDate: '2024-01-01',
    endDate: '2024-01-31',
  },
};
